import Vue from "vue";
import Vuex from "vuex";


const LIBRARY_BOOK_TYPE = 'bid';
const CLOUD_BOOK_TYPE = 'cid';

const SUMMARY_COUNT = 10;

Vue.use(Vuex);

function isChaptered(type) {
  return (type == LIBRARY_BOOK_TYPE || type == CLOUD_BOOK_TYPE);
}

export default new Vuex.Store ({
    state: {
      busy: false,
      selectedLibId: 0,
      selectedProductId: null,
      selectedProductTitle: null,
      selectedProductAccess: null,
      kotobeeResources: {},
      kotobeeApi: null,
      bridge: null,
      productAccess: [],
      lastCursor: null,
    },
    actions: {
      loadProductAccessList({commit, state}, opts) {
        let cursor = state.lastCursor;
        var append = false;
        if (opts) append = opts.append;
        if (!append) cursor = null;
        state.kotobeeApi.getProductAccessList(SUMMARY_COUNT, cursor, function(payload) {
          commit('setProductAccessFromResponse', {append, payload});
        });
      },
      fetchKotobeeResources({commit, state}) {
        state.kotobeeApi.getKotobeeResources(function(resources) {
          commit('setKotobeeResources', resources);
        });
      },
      changeSelectedProduct({commit, state}, {id, title}) {
        commit('setSelectedProductId', id);
        commit('setSelectedProductTitle', title);

        let access = null
        //Check if we already have a cached productAccess for this product id
        //If we find it, we set the title and access
        for (let i = 0; i < state.productAccess.length; i++) {
          const p = state.productAccess[i];
          if (p.id == id) {
            access = p.access;//p.metafield?JSON.parse(p.metafield.value):{}
          }
        }
        if (access) {
          commit('setSelectedProductAccess', access);
        } else  { //Not found in the list
          //Fetch from the api
          state.kotobeeApi.getSingleProductAccess(id, function(payload) {
            access = payload.data.product.metafield?JSON.parse(payload.data.product.metafield.value):{};
            commit('addToProductAccessList', {id, title, access});
            commit('setSelectedProductAccess', access);
          });
        }
      },
      updateSelectedProductAccess({commit, state}, {type, itemId, isLinked, chapters}) {
        console.log('updateSelectedProductAccess called with :', {type, itemId, isLinked, chapters});
        let access = Object.assign({}, state.selectedProductAccess);
        if (chapters === null) chapters = '';

        if (isLinked) { //Make the product linked with this itemId of this type
          if (!access[type]) { //There isn't a link of this type yet
            access[type] = isChaptered(type) ? {} : [];
          }
          
          if (isChaptered(type)) {
            access[type][itemId] = {chapters};
          } else {
            if (access[type].indexOf(itemId) === -1)
              access[type].push(itemId);
          }
        
        } else { //Unlink this product from this itemId of this type
          if (access[type]) { //Otherwise, we need to do nothing
            if (isChaptered) {
              if (access[type][itemId]) {
                delete access[type][itemId];
                if (Object.keys(access[type]).length === 0) {
                  delete access[type];
                }
              }
            } else {
              let index = access[type].indexOf(itemId);
              if (index !== -1) {
                access[type].splice(index, 1);
                if (access[type].length === 0)
                  delete access[type];
              }
            }
          }
        }
        commit('setSelectedProductAccess', access);
      },
      submitModifiedAccess({commit, state}, callback) {
        let access = state.selectedProductAccess;
        let gid = state.selectedProductId; //eg. gid://shopify/Product/6151800324282
        gid = gid.split('/');
        let id = gid[gid.length-1];

        state.kotobeeApi.updateProductAccess(id, access, function(response) {
          console.log("Product access updated, response: ", response);
          commit('updateProductInProductAccessList', {id, access});
          if(callback)
            callback(response);
        });
      },
      fetchShopifySettings({state}, callback) {
          state.kotobeeApi.getShopifySettings((response) => {
            callback(response);
          });
      },
      getProduct({state}, options) {
          state.kotobeeApi.getProduct(options.product_id, options.callback);
      },

      pushShopifySettings({state}, {data, callback}) {
          state.kotobeeApi.postShopifySettings(data, callback);
      },
      createCharge({state}, {data, callback}) {
          state.kotobeeApi.createCharge(data, callback);
      },
    },
    mutations: {
      setBusy(state, busy) {
        state.busy = busy;
      },
      addToProductAccessList(state, product) {
        state.productAccess.push(product);
      },
      updateProductInProductAccessList(state, {id, access}) {
        state.busy = false;
        for (let i = 0; i < state.productAccess.length; i++) {
          const p = state.productAccess[i];
          if (p.id == id) {
            state.productAccess[i].access = access;
            break;
          }
        }
      },
      setProductAccessFromResponse(state, {append, payload}) {
        state.busy = false;
        if (payload.data && payload.data.products) {
          let products = payload.data.products.edges;
          let hasMore = payload.data.products.pageInfo.hasNextPage;
          if (products.length) {
            if (!append) { //Clear the current productAccess list
              state.productAccess = [];
            }

            //Save last product cursor to use it in 'load more' request 
            if (hasMore)
              state.lastCursor = products[products.length-1].cursor;
            else
              state.lastCursor = null;
            
            //Append new products to the list
            for (let i=0; i<products.length; i++) {
              const p = products[i].node;
              state.productAccess.push({
                id: p.id,
                title: p.title,
                access: p.metafield?JSON.parse(p.metafield.value):{}
              });
            }
          } 
        }
      },
      setKotobeeApi(state, kApi) {
          state.kotobeeApi = kApi;
      },
      setBridge(state, bridge) {
          state.bridge = bridge;
      },
      setKotobeeResources(state, payload) {
        state.busy = false;
        state.kotobeeResources = payload;
      },
      selectLib(state, id) {
        state.selectedLibId = id;
      },
      setSelectedProductId(state, id) {
        state.selectedProductId = id;
      },
      setSelectedProductTitle(state, title) {
        state.selectedProductTitle = title;
      },
      setSelectedProductAccess(state, access) {
        state.selectedProductAccess = Object.assign({}, access);
      }
    }
  })
